module.exports = __webpack_public_path__ + "img/product-placeholder-37.607a251.png";